import * as XLSX from "xlsx";

const parseTextFile = (file: File): Promise<string> =>
	new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.onload = () => {
			if (typeof reader.result === "string") resolve(reader.result);
			else reject(new Error("Failed to read file as text"));
		};
		reader.onerror = () => reject(new Error("Failed to read file"));
		reader.readAsText(file);
	});

const parseExcelFile = (file: File): Promise<string> =>
	new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.onload = () => {
			try {
				const wb = XLSX.read(reader.result, { type: "array" });
				const sheets: string[] = [];
				for (const sheetName of wb.SheetNames) {
					sheets.push(`--- Sheet: ${sheetName} ---\n${XLSX.utils.sheet_to_csv(wb.Sheets[sheetName])}`);
				}
				resolve(sheets.join("\n\n"));
			} catch {
				reject(new Error("Failed to parse Excel file"));
			}
		};
		reader.onerror = () => reject(new Error("Failed to read file"));
		reader.readAsArrayBuffer(file);
	});

const isTextFile = (name: string) => name.endsWith(".csv") || name.endsWith(".tsv") || name.endsWith(".txt");

const isExcelFile = (name: string) => name.endsWith(".xlsx") || name.endsWith(".xls");

const parseFileToText = (file: File): Promise<string> => {
	const name = file.name.toLowerCase();
	if (isTextFile(name)) return parseTextFile(file);
	if (isExcelFile(name)) return parseExcelFile(file);
	return Promise.reject(new Error("Unsupported file type. Use CSV, TSV, TXT, XLS, or XLSX."));
};

export default parseFileToText;
